export default [
    {
        path: "/bq-store/ledger",
        component: () => import("./List.vue"),
        name: "bq.store.account.ledger",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/ledger/create",
        component: () => import("./Create.vue"),
        name: "bq.store.account.ledger.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/ledger/:id/edit",
        component: () => import("./Edit.vue"),
        name: "bq.store.account.ledger.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/ledger-barcode",
        component: () => import("./Barcode.vue"),
        name: "bq.store.account.ledger.barcode",
        meta: {
            requiresAuth: true,
        },
    },
];
